<template>
  <v-layout>
    <v-dialog v-model="show" max-width="1200px" lazy>
      <v-toolbar card dark color="primary">
        <v-btn icon dark @click.stop="show=false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ editedItem.name }} - {{ currentYear }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-tabs
        v-model="activeTab"
        color="primary"
        dark
        show-arrows
        >
        <v-tabs-slider color="white"></v-tabs-slider>

        <v-tab href="#tab-1">
          General Info
        </v-tab>

        <v-tab href="#tab-2">
          Contacts
        </v-tab>

        <v-tab href="#tab-3">
          {{ currentYear }} Info
        </v-tab>

        <v-tab href="#tab-4">
          Notes
        </v-tab>

        <v-tab href="#tab-5">
          Files
        </v-tab>

        <v-tab href="#tab-6">
          History
        </v-tab>

        <v-tab href="#tab-7">
          Email
        </v-tab>

        <v-tab href="#tab-8">
          Accounting
        </v-tab>

        <v-tab href="#tab-9">
          Photos
        </v-tab>

        <v-tab-item :value="'tab-1'">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 md7 order-xs2 order-md1>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs6 md3>
                            <v-select
                              v-model="editedItem.new"
                              :items="yesNo"
                              label="Waitlist"
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 md3>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 md9></v-flex>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItem.name"
                              @keyup.enter="save"
                              label="Name"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="editedItem.abbrev"
                              @keyup.enter="save"
                              label="Abbrev"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.address"
                          @keyup.enter="save"
                          label="Address"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap>
                          <v-flex xs10 md5>
                            <v-text-field
                              v-model="editedItem.city"
                              @keyup.enter="save"
                              label="City"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 md2>
                            <v-text-field
                              v-model="editedItem.state"
                              @keyup.enter="save"
                              label="ST"
                              mask="AA"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md5>
                            <v-text-field
                              v-model="editedItem.zip"
                              @keyup.enter="save"
                              label="Zipcode"
                              mask="#####"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-flex>
                    <v-flex xs12 md5 order-xs1 order-md2 class="text-xs-center ">
                      <v-img v-if="editedItem.logo" @click="fileDialog = !fileDialog" class="mx-auto" max-width="250" :src="editedItem.picture" alt="Company Logo" />
                      <v-img v-else class="mx-auto" @click="fileDialog = !fileDialog" max-width="250" src="/static/img/new.png" alt="Company Logo" />
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.phone"
                        @keyup.enter="save"
                        label="Phone"
                        mask="(###) ###-####"
                        return-masked-value
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.country"
                        @keyup.enter="save"
                        label="Country"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-text-field
                        v-model="editedItem.password"
                        @keyup.enter="save"
                        label="Password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.webSite"
                        @keyup.enter="save"
                        label="Website"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-select
                        v-model="editedItem.VendorCategoryId"
                        :items="categories"
                        item-text="category"
                        item-value="id"
                        label="Category"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editedItem.profile"
                        label="Company Profile"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="red darken-1"
                  flat
                  @click.native="deleteItem"
                >Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-tab-item>

        <v-tab-item :value="'tab-2'">
          <ContactList
            :item="item"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-3'">
          <v-form
            ref="form2"
            v-model="valid2"
            lazy-validation
          >
            <v-card>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs6 md3>
                      <v-select
                        v-model="editedItem.VendorDetails[0].waitList"
                        :items="yesNo"
                        label="Wait List"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-select
                        v-model="editedItem.VendorDetails[0].rating"
                        :items="rating"
                        label="Rating"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-select
                        v-model="editedItem.VendorDetails[0].terms"
                        :items="required"
                        item-text="name"
                        item-value="value"
                        label="Terms"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-select
                        v-model="editedItem.VendorDetails[0].checkIn"
                        :items="vendTypes"
                        item-text="name"
                        item-value="value"
                        label="Type"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].businessLicense"
                        @keyup.enter="saveDetail"
                        label="Elbert County Food License"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md4>
                      <v-autocomplete
                        :items="memberList"
                        item-text="fullName"
                        item-value="id"
                        v-model="editedItem.VendorDetails[0].UserId"
                        label="Rep"
                        hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 md4>
                      <v-select
                        v-model="editedItem.VendorDetails[0].concert"
                        :items="concertTypes"
                        item-text="name"
                        item-value="value"
                        label="Event"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].parkingRequired"
                        @keyup.enter="saveDetail"
                        label="Parking Required"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].parkingIssued"
                        @keyup.enter="saveDetail"
                        label="Parking Issued"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].badgesIssued"
                        @keyup.enter="saveDetail"
                        label="Badges Issued"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].badgesReturned"
                        @keyup.enter="saveDetail"
                        label="Badges Required"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md2>
                      <v-text-field
                        v-model="editedItem.VendorDetails[0].wristbandsIssued"
                        @keyup.enter="saveDetail"
                        label="Wristbands Issued"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-autocomplete
                        :items="contacts"
                        item-text="fullName"
                        item-value="id"
                        v-model="editedItem.VendorDetails[0].primaryContact"
                        label="Primary Contact"
                        hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-autocomplete
                        :items="contacts"
                        item-text="fullName"
                        item-value="id"
                        v-model="editedItem.VendorDetails[0].billingContact"
                        label="Billing Contact"
                        hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-autocomplete
                        :items="contacts"
                        item-text="fullName"
                        item-value="id"
                        v-model="editedItem.VendorDetails[0].primaryOnsite"
                        label="Primary Onsite"
                        hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-autocomplete
                      :items="contacts"
                      item-text="fullName"
                      item-value="id"
                      v-model="editedItem.VendorDetails[0].secondaryOnsite"
                      label="Secondary Onsite"
                      hide-details
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 class="justify-right layout px-0">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="saveDetail">Save</v-btn>
                    </v-flex>
                    <v-flex xs12 class="headline">Booth Information</v-flex>
                    <v-flex xs12>
                      <v-data-table
                        :headers="boothHeaders"
                        :items="editedItem.VendorBooths"
                        hide-actions
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-center">{{ props.item.boothNumber }}</td>
                          <td class="text-xs-center">{{ props.item.size }}</td>
                          <td class="text-xs-center">{{ props.item.area }}</td>
                          <td class="text-xs-center">{{ props.item.location }}</td>
                          <td class="text-xs-center">{{ props.item.status }}</td>
                          <td class="justify-center layout px-0">
                            <v-icon
                              @click="updateBooth(props.item)"
                            >
                              delete
                            </v-icon>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        v-model="newBoothId"
                        :items="newBooths"
                        item-text="boothLocation"
                        item-value="id"
                        label="New Booth"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 class="justify-right layout px-0">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="addBooth">Save Booth</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-form>
        </v-tab-item>

        <v-tab-item :value="'tab-4'">
          <NotesList
            :item="item"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-5'">
          <FilesList
            :item="item"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-6'">
          <HistoryList
            :item="item"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-7'">
          <EmailList
            :item="item"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-8'">
          <AccountingList
            :item="item"
            :currentYear="currentYear"
            :key="item.id"
            persistent
          />
        </v-tab-item>

        <v-tab-item :value="'tab-9'">
          <PhotosList
            :item="item"
            :currentYear="currentYear"
            :key="item.id"
            persistent
          />
        </v-tab-item>
      </v-tabs>
    </v-dialog>

    <v-dialog
      v-model="fileDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Upload Logo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="saveFile">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
            <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="image/*"
                  @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import ContactList from './ContactList.vue'
import NotesList from './NotesList.vue'
import HistoryList from './HistoryList.vue'
import FilesList from './FileList.vue'
import AccountingList from './AccountingList.vue'
import PhotosList from './PhotoList.vue'
import EmailList from './EmailList.vue'

export default {
  props: ['visible', 'item', 'memberList', 'currentYear'],

  components: {
    ContactList,
    NotesList,
    HistoryList,
    FilesList,
    AccountingList,
    PhotosList,
    EmailList
  },

  data () {
    return {
      valid: true,
      valid2: true,
      activeTab: '',
      newBoothId: 0,
      saving: false,
      fileDialog: false,
      rating: ['1', '2', '3', '4', '5'],
      yesNo: ['Yes', 'No'],
      required: [
        { name: 'Received', value: 'Yes' },
        { name: 'Required', value: 'No' }
      ],
      vendTypes: ['Vendor', 'Sponsor', 'Non-Profit'],
      returnings: [
        { name: '', value: '' },
        { name: 'Rodeo', value: 'Yes' },
        { name: 'Rodeo and Concert', value: 'Both' }
      ],
      concertTypes: ['Both Rodeo and Concert', 'Rodeo Only', 'Concert Only'],
      statuses: ['Going', 'Wait List'],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      boothHeaders: [
        {text: 'Booth #', align: 'center', sortable: false, value: 'boothNumber'},
        {text: 'Size', align: 'center', sortable: false, value: 'size'},
        {text: 'Area', align: 'center', sortable: false, value: 'area'},
        {text: 'Location', align: 'center', sortable: false, value: 'location'},
        {text: 'Status', align: 'center', sortable: false, value: 'Status'},
        {text: 'Remove', align: 'center', sortable: false, value: 'id'}
      ],
      permitHeaders: [
        {text: 'Type', align: 'center', sortable: false, value: 'type'},
        {text: 'Number', align: 'center', sortable: false, value: 'permitNumber'},
        {text: 'Note', align: 'center', sortable: false, value: 'note'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      editedItem: this.item,
      titleName: '',
      categories: [],
      contacts: [],
      newBooths: [],
      permits: [],
      dates: [],
      fileName: null,
      files: []
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    // this.currentYear = this.$store.state.currentYear

    this.getCategories()
    this.getContacts()
    this.getBooths()
    this.getPermits()
    this.loadItem()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    async loadItem () {
      try {
        this.editedItem = this.item
        const response = await Api().get('vendor_booths/' + this.currentYear + '/' + this.item.id)
        this.item.VendorBooths = response.data

        let test = this.item.VendorBooths.sort((a, b) => {
          let fa = a.boothNumber
          let fb = b.boothNumber

          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }

          return 0
        })

        this.item.VendorBooths = test
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },

    async getCategories () {
      try {
        const response = await Api().get('categories/')
        this.categories = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async printForm (date) {
      try {
        await Api().post('get_pdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/out.pdf', '_blank')
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveFile () {
      let filenames = []

      let formData = new FormData()
      formData.append('fileName', this.fileName)
      formData.append('id', this.item.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_logo', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.editedItem.logo = response.data.logo
        this.editedItem.picture = process.env.API_URL + '/vendor/images/' + response.data.logo

        this.fileDialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      if (this.$refs.form.validate()) {
        try {
          const response = await Api().put('vendors/' + this.editedItem.id, this.editedItem)

          console.log(response.data)
          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async saveDetail () {
      try {
        this.editedItem.VendorDetails[0].year = this.currentYear

        const response = await Api().put('vendor_details/' + this.editedItem.VendorDetails[0].id, this.editedItem.VendorDetails[0])

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateBooth (item) {
      try {
        item.VendorCompanyId = null

        const response = await Api().put('vendor_booths/' + item.id, item)

        const arr = this.item.VendorBooths.filter(booth => booth.id !== item.id)

        this.item.VendorBooths = arr
        this.getBooths()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getContacts () {
      try {
        const response = await Api().get('vendor_contacts/' + this.item.id)

        this.contacts = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getBooths () {
      try {
        const response = await Api().get('new_booths/' + this.currentYear)

        this.newBooths = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addBooth () {
      try {
        let item = {}
        item.VendorCompanyId = this.item.id

        const response = await Api().put('vendor_booths/' + this.newBoothId, item)

        console.log(response.data.booth)
        this.item.VendorBooths.push(response.data.booth)

        let test = this.item.VendorBooths.sort((a, b) => {
          let fa = a.boothNumber
          let fb = b.boothNumber

          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }

          return 0
        })

        this.item.VendorBooths = test

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getPermits () {
      try {
        const response = await Api().get('permits/' + this.currentYear + '/' + this.item.id)

        this.permits = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addPermits () {
      try {
        let item = {}
        item.VendorCompanyId = this.item.id

        const response = await Api().put('vendor_booths/' + this.newBoothId, item)

        console.log(response.data.booth)
        this.item.VendorBooths.push(response.data.booth)

        let test = this.item.VendorBooths.sort((a, b) => {
          let fa = a.boothNumber
          let fb = b.boothNumber

          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }

          return 0
        })

        this.item.VendorBooths = test

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.fileDialog = false
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/InternalForm.vue